
import React, { useState, useEffect } from 'react';
import { useProfileData } from '@/hooks/useProfileData';
import { useAccount } from '@/contexts/AccountContext';
import { DashboardContent } from './DashboardContent';
import { SimplifiedDashboard } from './SimplifiedDashboard';

export const ResilientDashboardLoader: React.FC = () => {
  const [showDashboard, setShowDashboard] = useState(false);
  
  const { data: profile, isLoading: profileLoading, error: profileError } = useProfileData();
  const { currentAccount, isLoading: accountLoading } = useAccount();

  console.log('[ResilientDashboard] State:', {
    profileLoading,
    profileError: profileError?.message,
    hasProfile: !!profile,
    accountLoading,
    hasAccount: !!currentAccount,
    showDashboard
  });

  // Show dashboard after short timeout or when data is ready
  useEffect(() => {
    if (profile || currentAccount) {
      console.log('[ResilientDashboard] Data available, showing dashboard');
      setShowDashboard(true);
      return;
    }

    const timer = setTimeout(() => {
      console.log('[ResilientDashboard] Timeout reached, showing dashboard');
      setShowDashboard(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, [profile, currentAccount]);

  // Show simplified dashboard if there's an error
  if (profileError && showDashboard) {
    console.log('[ResilientDashboard] Using simplified mode due to error');
    return (
      <SimplifiedDashboard 
        firstName={profile?.first_name || 'User'} 
        error={`Data loading issue - showing simplified view`}
      />
    );
  }

  // Show loading only for the first 2 seconds
  if (!showDashboard) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        flexDirection: 'column',
        backgroundColor: '#ffffff'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid #e5e7eb',
          borderTop: '3px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '1rem'
        }} />
        <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
          Loading dashboard...
        </p>
        <style>
          {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
        </style>
      </div>
    );
  }

  // Always show dashboard content after timeout
  console.log('[ResilientDashboard] Rendering dashboard content');
  return <DashboardContent />;
};
